// NEXTRIBE: ActiveStorage経由のファイルリンクをクリックしたとき、ブラウザー上で開かずに
// ダウンロードダイアログを表示させる。
// GCSの署名付きURLは response-content-disposition を署名に含めないためGCS側で無視される。
// そのため disposition=attachment を付けたリンクはRails経由で配信させている
// (app/controllers/authenticated_files_controller.rb)。

const BLOB_PATH = '/rails/active_storage/blobs/'

// ダウンロードさせる拡張子。
// Rails(Cloud Run)を経由する配信になるため対象を限定している。
// authenticated_files_controller.rb の DOWNLOADABLE_EXTENSIONS と揃えること。
// 画像・動画はブラウザー上で表示・再生させ、PDFは pdf-viewer.js でビューア化するため対象外。
const DOWNLOAD_EXTENSIONS = ['md', 'zip']

function extensionOf(pathname) {
  const filename = pathname.split('/').pop()
  return filename.includes('.') ? filename.split('.').pop().toLowerCase() : ''
}

// ダウンロードさせるべきリンクなら書き換え後のURLを返し、対象外ならnullを返す
function attachmentUrl(href) {
  let url
  try {
    url = new URL(href, window.location.origin)
  } catch (_) {
    // mailto: などURLとして解釈できないhrefは対象外
    return null
  }

  if (!url.pathname.includes(BLOB_PATH)) return null
  if (url.searchParams.has('disposition')) return null
  if (!DOWNLOAD_EXTENSIONS.includes(extensionOf(url.pathname))) return null

  url.searchParams.set('disposition', 'attachment')

  // 相対パスで書かれたリンクは相対パスのまま返す
  return href.startsWith('/')
    ? `${url.pathname}${url.search}${url.hash}`
    : url.toString()
}

export default function (md) {
  const defaultRender =
    md.renderer.rules.link_open ||
    function (tokens, idx, options, _env, self) {
      return self.renderToken(tokens, idx, options)
    }

  md.renderer.rules.link_open = function (tokens, idx, options, env, self) {
    const token = tokens[idx]
    const hrefIndex = token.attrIndex('href')

    if (hrefIndex >= 0) {
      const url = attachmentUrl(token.attrs[hrefIndex][1])
      if (url) {
        token.attrs[hrefIndex][1] = url
      }
    }

    return defaultRender(tokens, idx, options, env, self)
  }
}
